export class ItemCache<T> {
  private _value: T | undefined
  private ttl: number
  private expiresAt: number

  constructor(options: { ttl?: number; value?: T }) {
    this._value = options.value
    this.ttl = options.ttl ?? Infinity
    this.expiresAt = Date.now() + this.ttl
  }

  get value() {
    if (Date.now() > this.expiresAt) {
      this._value = undefined
    }
    return this._value
  }

  set value(value: T | undefined) {
    this._value = value
    this.expiresAt = Date.now() + this.ttl
  }

  clear() {
    this._value = undefined
  }
}
